import { Zap } from 'lucide-react';

import type { Site } from '@/api/fe-api/domain/entities/site';
import { PowerEnergy } from '@/components/sites/power-energy';
import { StatsBox } from '@/modules/documents/view/components/pages/site-overview/stats-box';

export type CardPowerEnergyProps = {
  site: Site;
  className?: string;
};

export function CardPowerEnergy({ site, className }: CardPowerEnergyProps) {
  return (
    <StatsBox
      className={className}
      title="Power/Energy"
      value={<PowerEnergy site={site} />}
      icon={{ element: <Zap />, color: 'neutral' }}
    />
  );
}
